(function () {
  var ALLOWED_ORIGINS = ['https://getskinmatch.com', 'https://www.getskinmatch.com'];
  var CART_ADD_URL = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';

  function stripLeadingZeros(raw) {
    var s = String(raw || '').replace(/\D/g, '');
    return s.replace(/^0+/, '') || s;
  }

  function parseEanList(raw) {
    return String(raw || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function suggestByBarcode(query) {
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[options][fields]=variants.barcode'
      + '&resources[limit]=1';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return null;
        var list = j.resources && j.resources.results && j.resources.results.products;
        return (list && list[0]) || null;
      });
  }

  function variantIdFromProductUrl(url) {
    var m = /[?&]variant=(\d+)/.exec(url || '');
    return m ? parseInt(m[1], 10) : null;
  }

  function firstVariantIdForHandle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        var available = p.variants.find(function (v) { return v.available; });
        return (available || p.variants[0]).id;
      });
  }

  function resolveEanToVariantId(ean) {
    var candidates = [ean, stripLeadingZeros(ean)].filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    var chain = Promise.resolve(null);
    candidates.forEach(function (q) {
      chain = chain.then(function (hit) {
        if (hit) return hit;
        return suggestByBarcode(q);
      });
    });
    return chain.then(function (product) {
      if (!product) return null;
      var variantId = variantIdFromProductUrl(product.url);
      if (variantId) return { id: variantId, handle: product.handle, title: product.title };
      return firstVariantIdForHandle(product.handle).then(function (id) {
        return id ? { id: id, handle: product.handle, title: product.title } : null;
      });
    }).catch(function () { return null; });
  }

  function addItemsToCart(items) {
    return fetch(CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw body;
        return body;
      });
    });
  }

  function notifyThemeCart(totalQty) {
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { quantity: totalQty, variant: null }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function handleAddToCart(data) {
    var eans = parseEanList(data.ean);
    if (!eans.length) return;

    Promise.all(eans.map(function (ean) {
      return resolveEanToVariantId(ean).then(function (hit) { return { ean: ean, hit: hit }; });
    })).then(function (results) {
      var items = [];
      var missing = [];
      results.forEach(function (r) {
        if (r.hit) items.push({ id: r.hit.id, quantity: 1 });
        else missing.push(r.ean);
      });

      if (missing.length) {
        console.warn('[SkinMatch] No Shopify variant found for EAN(s):', missing);
      }
      if (!items.length) return;

      return addItemsToCart(items).then(function (res) {
        notifyThemeCart(items.length);
        console.log('[SkinMatch] Added to cart:', res);
      });
    }).catch(function (err) {
      console.error('[SkinMatch] Cart add failed:', err);
    });
  }

  window.addEventListener('message', function (e) {
    if (ALLOWED_ORIGINS.indexOf(e.origin) === -1) return;
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    if (d.action === 'add-to-cart') handleAddToCart(d);
  });
})();